<template>
    <template v-if="item.idBlockType === 3">
      <template v-for="(survey, i) in surveys" :key="i">
     
        <SurveyCard
          :style="{ '--i': i }"
          v-if="showList1 && showList2 && item.idBlockType === 3"
          :title="item.nome"
          :survey-duration="survey.fine"
          :users="survey.surveys"
          @click="
            pkSurveyStore.setCurrentSurvey(
              JSON.parse(JSON.stringify(survey.survey[0]))
            );
            generalStore.setCurrentSurvey(
              JSON.parse(JSON.stringify(survey.survey[0]))
            );
          "
        />
      </template>
    </template>
</template>
<script>
import { defineComponent } from "vue";
import SurveyCard from "../../views/pk_views/components/SurveyCard.vue"; 

export default defineComponent({
  components: {
    SurveyCard,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    surveys: {
      type: Array,
      required: true,
    },
    showList1: {
      type: Boolean,
      required: true,
    },
    showList2: {
      type: Boolean,
      required: true,
    },
  },
});
</script>
<style scoped>
.chapter-image img {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 10px;
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


</style>

